import { SteemActionType } from '@popup/steem/actions/action-type.enum';
export const AccountReducer = (state = [], { type, payload }) => {
    switch (type) {
        case SteemActionType.GET_ACCOUNTS: {
            const accounts = payload;
            return accounts;
        }
        case SteemActionType.SET_ACCOUNTS: {
            const accounts = payload;
            return accounts;
        }
        case SteemActionType.ADD_ACCOUNT: {
            const account = payload;
            return [...state, account];
        }
        case SteemActionType.RESET_ACCOUNT:
            return [];
        default:
            return state;
    }
};
